// Third Party
import * as $ from 'jquery';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Services
import documentService from '@/app/services/main/document/document-service.js';

// Constants
import { FILE_TYPE } from '@/app/constants/type-constants.js';
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/status-constants';

export default {
    name: 'ModalAddEditDeleteDocument',
    mixins: [toastMessageMixins, userMixins ],
    data() {
        return {
            modalContent: null,
            url:null,
            hasImage:false,
            description:'',
            fileName:null,
            document:null,
            isAPILoading:false,
            title:'',
            tempDescription:null,
            content:{}
        }
    },
    beforeDestroy() {
        this.hideModal();
    },
    methods: {
        show(content,type) {
            this.clearFields();
            this.title = type;

            if (type == "Upload"){
                this.document = content;
                this.url = this.fileFormat(content.type);
                this.fileName = content.name;

                if(this.url === null){
                    this.hasImage = true;
                    const fileReader = new FileReader()
                    fileReader.addEventListener('load', () => {
                        this.url = fileReader.result;
                    })
                    fileReader.readAsDataURL(content);
                }
            }

            if (type == "Edit"){
                this.content = content;
                this.fileName = content.name;
        
                let descriptionTemp = content.description;
                if (this.fileName.slice(0, 20) === content.description.slice(0, 20)) {
                    descriptionTemp = '';
                }
                this.tempDescription=descriptionTemp;
                this.description = descriptionTemp;
                this.url =  this.fileType(content.type);
                
                if(this.url === null){
                    this.hasImage = true;
                    this.url = content.documentUrl;
                }
            }

            if (type == "Delete"){
                this.content = content;
                this.fileName = content.name;
        
                let descriptionTemp = content.description;
                if (this.fileName.slice(0, 20) === content.description.slice(0, 20)) {
                    descriptionTemp = '';
                }
                this.tempDescription=descriptionTemp;
                this.description = descriptionTemp;
                
                this.url =  this.fileType(content.type);
                
                if(this.url === null){
                    this.hasImage = true;
                    this.url = content.documentUrl;
                }
            }
        
            $(this.$refs.modalAddEditDeleteDocument).modal('show');
        },
        hideModal() {
            this.clearFields();
            $(this.$refs.modalAddEditDeleteDocument).modal('hide');
        },
        refreshTable() {
            this.hideModal();
            this.$emit('getTableContent');
        },
        clearFields() {
            this.modalContent=null;
            this.url=null;
            this.hasImage=false;
            this.description='';
            this.fileName=null;
            this.document=null;
            this.isAPILoading=false;
        },
        fileFormat(type){
            const fileTypeImages = {
                [FILE_TYPE.DOC]: require('@/assets/images/file-type/word.svg'),
                [FILE_TYPE.PDF]: require('@/assets/images/file-type/pdf.svg'),
                [FILE_TYPE.EXCEL]: require('@/assets/images/file-type/excel.svg'),
                [FILE_TYPE.CSV]: require('@/assets/images/file-type/excel.svg'),
                [FILE_TYPE.PPT]: require('@/assets/images/file-type/ppt.svg'),
                [FILE_TYPE.TXT]: require('@/assets/images/file-type/txt.svg'),
                [FILE_TYPE.HTML]: require('@/assets/images/file-type/php.svg'),
                [FILE_TYPE.ZIP]: require('@/assets/images/file-type/zip.svg'),
                [FILE_TYPE.RAR]: require('@/assets/images/file-type/zip.svg'),
            };

            return fileTypeImages[type] || null;
        },
        fileType(type){

            const fileTypeExtensions = {
                ['docx']: require('@/assets/images/file-type/word.svg'),
                ['pdf']: require('@/assets/images/file-type/word.svg'),
                ['xlsx']: require('@/assets/images/file-type/word.svg'),
                ['csv']: require('@/assets/images/file-type/word.svg'),
                ['pptx']: require('@/assets/images/file-type/word.svg'),
                ['txt']: require('@/assets/images/file-type/word.svg'),
                ['html']: require('@/assets/images/file-type/word.svg'),
                ['zip']: require('@/assets/images/file-type/word.svg'),
                ['rar']: require('@/assets/images/file-type/word.svg'),
            }

            return fileTypeExtensions[type] || null;
        },
        uploadDocument(){
            this.isAPILoading = true;
            let tempDescription = this.description === '' ? this.fileName.slice(0, 20) : this.description;

            let docDetails = {
                formDetails: {
                    "petId": this.getActivePet.id,
                    "description": tempDescription
                },
                document: this.document
            };

            documentService.postDocument(docDetails)
                .then(res => {
                    const { ERROR_UPLOAD_DOCUMENT, SUCCESS_UPLOAD_DOCUMENT } = this.toastMessages.document();
                    if (res.status ===  STATUS_CODES.SUCCESS_NO_CONTENT) {
                        this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPLOAD_DOCUMENT);
                        this.isAPILoading = false;

                        this.refreshTable();
                    } else {
                        this.isAPILoading = false;
                        this.showAPIErrorToast(ERROR_UPLOAD_DOCUMENT, res);
                        this.refreshTable();
                    }
                });
        },
        updateDocument(){
            this.isAPILoading = true;

            let docInfo = {
                "petId":this.content.petId,
                "description": this.description
            }
            
            let docId = this.content.id;

            this.$emit('setDocumentsList', "Edit", {...this.content, description: this.description});
            
            documentService.updateDocument(docInfo, docId)
                .then(res => {
                    const { ERROR_UPDATE_REMINDER, SUCCESS_UPDATE_DOCUMENT } = this.toastMessages.document();
                    if (res.status ===  STATUS_CODES.SUCCESS_NO_CONTENT) {
                        this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_DOCUMENT);
                        this.isAPILoading = false;

                        this.refreshTable();
                    } else {
                        this.isAPILoading = false;
                        this.showAPIErrorToast(ERROR_UPDATE_REMINDER, res);
                        this.refreshTable();
                    }
                });
        },
        deleteDocument(){
            this.$swal({
                imageHeight: '30px',
                title: 'Are you sure you want to delete this document?',
                imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
                confirmButtonText: 'Confirm',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                reverseButtons: true,
            })
            .then(result => {
                if (result.value) {
                    this.isAPILoading = true;
        
                    let petInfo = {
                        "petId": this.content.petId
                    }
                    
                    let docId = this.content.id;

                    this.$emit('setDocumentsList', "Delete", this.content);
                    
                    documentService.deleteDocument(petInfo, docId)
                        .then(res => {
                            const { ERROR_DELETE_REMINDER, SUCCESS_DELETE_DOCUMENT } = this.toastMessages.document();
                            if (res.status ===  STATUS_CODES.SUCCESS_NO_CONTENT) {
                                this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_DELETE_DOCUMENT);
                                this.isAPILoading = false;
        
                                this.refreshTable();
                            } else {
                                this.isAPILoading = false;
                                this.showAPIErrorToast(ERROR_DELETE_REMINDER, res);
                                this.refreshTable();
                            }
                        });
                }
            });  
        }
    }
}